import { distributionCutoffService } from '../services/distributionCutoff.service';

const state = {
  cutoff: null,
  email: null,
  loading: true
};

const actions = {
  getData({ dispatch, commit }) {
    commit('setLoadingState', true);
    return distributionCutoffService.getDistributionCutoff()
      .then(res => {
        commit('changeDistribution', { cutoff: res.data });
        commit('setLoadingState', false);
      })
      .catch(() => {
        dispatch('alert/error', 'Unable to get distribution data', { root: true });
        commit('setLoadingState', false);
      });
  },
  postData({ dispatch, commit }, { cutoff, email }) {
    commit('setLoadingState', true);
    return distributionCutoffService.postDistributionCutoff(cutoff, email)
      .then(res => {
        commit('changeDistribution', { cutoff: res.data });
        commit('setLoadingState', false);
        dispatch('alert/success', 'Distribution set successfully', { root: true });
      })
      .catch(() => {
        dispatch('alert/error', 'Unable to set distribution data', { root: true });
        commit('setLoadingState', false);
      });
  }
};

const mutations = {
  changeDistribution(state, payload) {
    state.cutoff = payload.cutoff;
  },
  setLoadingState(state, payload) {
    state.loading = payload;
  }
};

export const distributionCutoff = {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/distributionCutoff.module.js